"use client";

import React, { FC } from "react";

import { UniversalComponent } from "~/components/universal-component/component";
import { commonComponentsConfig } from "~/constants/components-configs/common-config";
import { srpPageConfig } from "~/constants/components-configs/srp-config";
import { FetchPageReturnType } from "~/transport/types";

export const PageClientComponent: FC<{ pageContent: FetchPageReturnType }> = ({
  pageContent,
}) => {
  const { component, props, children, _meta: meta } = pageContent;

  const componentConfigs = [srpPageConfig, commonComponentsConfig];

  return (
    <UniversalComponent
      meta={meta}
      component={component ?? undefined}
      elements={children ?? null}
      props={{ ...props }}
      componentsConfigs={componentConfigs}
    />
  );
};
